export default `
query Divisions(
  $serviceProviderId: ID!,
  $to: Float,
  $from: Float,
  $after: String
) {
  queryDivisionsByServiceProviderIdUpdatedAtIndex(
    serviceProviderId: $serviceProviderId,
    to: $to,
    from: $from,
    after: $after
  ) {
    items {
      divisionId
      displayName
      updatedAt
      serviceProviderId
      isDeleted
    }
    nextToken
  }
}
`;